export default "__VITE_ASSET__DFhafnJc__"